import React from 'react'
import { BackgroundWrapper, Left, Right, Separator } from './ElementsStyles'

export default function Background() {
  return (
    <>
      <BackgroundWrapper />
      <Left />
      <Separator />
      <Right />
    </>
  )
}
